import {Box, Text} from 'platform/foundation';

export interface TableColumnProps {
  title?: string;
}

export const TableColumn = (props: TableColumnProps) => (
  <Box padding={4} height={13} backgroundColor="palettes.neutral.10.100">
    <Text alternative size="small" align="left">
      {props.title}
    </Text>
  </Box>
);
